module.exports = __webpack_public_path__ + "img/cdn77.aeae6ba6.svg";